import en from './believeString.en';

export default {
  en,
};
